import React, { useState, useEffect } from "react";
import { useLanguage } from "../../Translations/LenguageContext";
import ErrorMessage from "../../Components/ErrorMessage";
import Spinner from "../../Components/Spinner";
import { useNavigate, useParams } from "react-router-dom";
import { VscAzure } from "react-icons/vsc";
import { FaAws } from "react-icons/fa";
import { SiGooglecloud, SiNvidia } from "react-icons/si";
import PricingModal from "../Database/PricingModal";
import azureRegions from "../../JSON/AzureRegions.json"
import continentFlags from "../../JSON/ContinentIcon.json"
import regionDisplayNames from "../../JSON/AzureDisplayNames.json"
import azureVmsMap from "../../JSON/AzureVMsMap.json"

const NewCluster = () => {
    const { t } = useLanguage();
    const { project_id } = useParams()
    const navigate = useNavigate();
    const [err, setErr] = useState({ message: "", display: false });
    const user_id = sessionStorage.getItem("user_id");
    const [loading, setLoading] = useState(false);
    const [loadingPage, setLoadingPage] = useState(true);
    const [interval, setSubsInterval] = useState("monthly");
    const [provider, setProvider] = useState("azure")
    const [k8sName, setK8sName] = useState("");
    const [description, setDescription] = useState("");
    const [nodes, setNodes] = useState(1);
    const [osType, setOsType] = useState("Linux");
    const [showPricingModal, setShowPricingModal] = useState(false)
    const [selectedRegion, setRegion] = useState("eastus");
    const [hasPayment, setPayments] = useState(true);
    const [availableVms, setAvailableVms] = useState([]);
    const [selectedVm, setSelectedVm] = useState("Shared_Erioon");
    const [loadingVMs, setLoadingVms] = useState(true)

    const goBack = () => {
        navigate(`/project_panel/${project_id}/clusters`);
    };

    const NewDb = async () => {
        if (!k8sName.trim()) {
            setErr({ message: "Please provide a name for the cluster", display: true });
            return;
        }

        if (!description.trim()) {
            setErr({ message: "Please provide a description for the cluster", display: true });
            return;
        }

        if (!nodes || nodes == 0) {
            setErr({ message: "Please provide a minimum of 1 node for the cluster", display: true });
            return;
        } else if (nodes < selectedVm.min_nodes) {
            setErr({ message: `The minimum nodes allowed for this resource  is ${selectedVm.min_nodes}`, display: true });
            return;
        } else if (nodes > selectedVm.max_nodes) {
            setErr({ message: `The maximum nodes allowed for this resource  is ${selectedVm.max_nodes}`, display: true });
            return;
        }

        if (!osType.trim()) {
            setErr({ message: "Please provide an OS Type for the cluster", display: true });
            return;
        }

        setLoading(true);
        let data = {
            user_id: user_id,
            project_id: project_id,
            selectedRegion: selectedRegion,
            k8sname: k8sName,
            nodes: nodes,
            osType: osType,
            description: description,
            interval: interval,
            vm_size: selectedVm.vm_size,
            provider: provider,
        }

        try {
            const response = await fetch("https://backend.erioon.com/create_k8s_cluster", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(data),
            });
            setLoading(false);
            if (response.ok) {
                const result = await response.json();
                const cluster_id = result.clus_id;
                navigate(`/project_panel/${project_id}/clusters/loading_cluster/${cluster_id}`);
            } else {
                console.error("Error creating db:", response.statusText);
            }
        } catch (error) {
            setLoading(false);
            console.error("db creation failed", error);
        }
    };


    const fetchRecords = async () => {
        setLoadingPage(false)
    };


    const fetchUserData = async () => {
        setLoading(true)
        try {
            const response = await fetch('https://backend.erioon.com/get_specific_data', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ user_id: user_id }),
            });
            setLoading(false)
            if (!response.ok) {
                throw new Error('Failed to fetch user data');
            }

            const data = await response.json();
            const payment_method = data.payment_method

            if (payment_method) {
                setPayments(true)
            } else {
                setPayments(false)
            }

        } catch (error) {
            setLoading(false)
            console.error("Error fetching user data:", error);
        }
    };


    useEffect(() => {
        fetchUserData()
    }, []);

    useEffect(() => {
        fetchRecords()
    }, [])


    useEffect(() => {
        const filtered = azureVmsMap.filter(vm =>
            vm.locations.includes(selectedRegion)
        );
        setLoadingVms(true)
        setTimeout(() => {
            setLoadingVms(false)
        }, 1000);
        setAvailableVms(filtered);
        setSelectedVm(filtered[0] || null);
    }, [selectedRegion]);



    if (loadingPage) {
        return <div className="loading_new_db_cont">
            <div className="loading_resources_new">
                <div className="loading_resources_new_main"></div>
                <div className="loading_resources_new_main"></div>
                <div className="loading_resources_new_main"></div>

            </div>
            <div className="loading_resume_new">
                <div className="loading_resume_new_main">

                </div>
            </div>
        </div>
    }

    return (
        <div>
            <div className="new_section_main_view">
                <p className="new_section_main_view_title">
                    <i className="fa-solid fa-chevron-left" onClick={goBack}></i> New cluster
                </p>
                <p className="new_section_main_view_subtitle">
                    Complete all the fields and create your cluster
                </p>

                {!hasPayment && (
                    <div className="no_payment_method_db">
                        <p>To proceed, please add a valid payment method to your account.</p>
                        <button className="add_payment_btn" onClick={() => navigate("/control_panel/billing")}><i className="fa-solid fa-plus"></i> Add payment method</button>
                    </div>
                )}

                <div className="new_section_main_input_cont">
                    <div className="new_section_main_input_container">

                        <p className="db_title">Choose a provider</p>
                        <div className="vendor_cont">
                            <div className={`vendor_item ${provider === "azure" ? "vendor_item_selected" : ""}`} onClick={() => setProvider("azure")}>
                                <p className="vendor_logo"><VscAzure /></p>
                                <p className="full_vendor_name">Microsoft Azure</p>
                            </div>
                            <div className={`vendor_item coming_soon_item ${provider === "aws" ? "vendor_item_selected" : ""}`} >
                                <p className="vendor_logo"><FaAws /></p>
                                <p className="full_vendor_name">Amazon AWS</p>
                                <p className="coming_soon">Coming soon!</p>
                            </div>
                            <div className={`vendor_item coming_soon_item ${provider === "gc" ? "vendor_item_selected" : ""}`}>
                                <p className="vendor_logo"><SiGooglecloud /></p>
                                <p className="full_vendor_name">Google Cloud</p>
                                <p className="coming_soon">Coming soon!</p>
                            </div>
                        </div>


                        <p className="db_title">Choose a location</p>
                        <div className="region_container">
                            <div className="region_block">
                                {["North America", "South America", "Australia"].map((continent) =>
                                    azureRegions[continent] ? (
                                        <div key={continent} className="continent_region">
                                            <p className="continent_title_region">
                                                {continentFlags[continent]} {continent}
                                            </p>
                                            <div className="reg_cont_main">
                                                {azureRegions[continent].map((region) => (
                                                    <div key={region} value={region} className={selectedRegion === region ? "single_region_selected" : "single_region"} onClick={() => setRegion(region)}>
                                                        {regionDisplayNames[region] || region}
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    ) : null
                                )}
                            </div>

                            <div className="region_block">
                                {["Europe", "Africa"].map((continent) =>
                                    azureRegions[continent] ? (
                                        <div key={continent} className="continent_region">
                                            <p className="continent_title_region">
                                                {continentFlags[continent]} {continent}
                                            </p>
                                            <div className="reg_cont_main">
                                                {azureRegions[continent].map((region) => (
                                                    <div key={region} value={region} className={selectedRegion === region ? "single_region_selected" : "single_region"} onClick={() => setRegion(region)}>
                                                        {regionDisplayNames[region] || region}
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    ) : null
                                )}
                            </div>

                            <div className="region_block">
                                {["Asia", "Middle East"].map((continent) =>
                                    azureRegions[continent] ? (
                                        <div key={continent} className="continent_region">
                                            <p className="continent_title_region">
                                                {continentFlags[continent]} {continent}
                                            </p>
                                            <div className="reg_cont_main">
                                                {azureRegions[continent].map((region) => (
                                                    <div key={region} value={region} className={selectedRegion === region ? "single_region_selected" : "single_region"} onClick={() => setRegion(region)}>
                                                        {regionDisplayNames[region] || region}
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    ) : null
                                )}
                            </div>
                        </div>
                        <p className="db_title">Select an available server in {regionDisplayNames[selectedRegion]}</p>
                        {loadingVMs ? (
                            <div className="loading_vm_cont">

                            </div>
                        ) : (
                            <div className="resource_container">
                                {availableVms.filter(vm => vm.type == "shared").length > 0 ? (
                                    availableVms
                                        .filter(vm => vm.type == "shared" && vm.available)
                                        .map((vm) => (
                                            <div
                                                key={vm.name}
                                                className={`resource_card ${selectedVm?.vm_size === vm.vm_size ? "resource_card_selected" : ""}`}
                                                onClick={() => setSelectedVm(vm)}
                                            >
                                                <p className="resource_card_title">
                                                    {vm.title} {vm.nvidia && (<span className="nvidia_logo"><SiNvidia /></span>)}
                                                </p>
                                                <p className="resource_card_description">
                                                    {vm.notes || "No description available"}
                                                </p>
                                                <div className="resource_card_items">
                                                    <p className="resource_card_items_inner">vCPUs {vm.vCPUs}</p>
                                                    <p className="resource_card_items_inner">RAM {vm.RAM_GB}GB</p>
                                                    {vm.GPU && (
                                                        <p className="resource_card_items_inner">GPU {vm.GPU}</p>
                                                    )}
                                                </div>
                                                {vm?.vm_size !== "Shared_Erioon" && (
                                                    <div className="resource_card_items">
                                                        <p className="resource_card_items_inner">Min Nodes {vm.min_nodes}</p>
                                                        <p className="resource_card_items_inner">Max Nodes {vm.max_nodes}</p>
                                                    </div>
                                                )}
                                                <p className="resource_card_price">
                                                    {vm.price_per_hour_usd != null
                                                        ? (vm.erioon_price < 0.09
                                                            ? `$${vm.erioon_price}`
                                                            : `$${vm.erioon_price.toFixed(2)}`
                                                        ) + "/hour"
                                                        : "Pricing unavailable"}
                                                </p>
                                            </div>
                                        ))
                                ) : (
                                    <p>No available shared VM options in this region.</p>
                                )}
                                {/* {availableVms.filter(vm => vm.type == "single").length > 0 && (
                                    availableVms
                                        .filter(vm => !vm.available)
                                        .map((vm) => (
                                            <div
                                                key={vm.name}
                                                className={`resource_card resource_card_not_available ${selectedVm?.vm_size === vm.vm_size ? "resource_card_selected" : ""}`}
                                                onClick={() => setSelectedVm(vm)}
                                            >
                                                <p className="resource_card_title">
                                                    {vm.title} {vm.nvidia && (<span className="nvidia_logo"><SiNvidia /></span>)}
                                                </p>
                                                <p className="resource_card_description">
                                                    {vm.notes || "No description available"}
                                                </p>
                                                <div className="resource_card_items">
                                                    <p className="resource_card_items_inner">vCPUs {vm.vCPUs}</p>
                                                    <p className="resource_card_items_inner">RAM {vm.RAM_GB}GB</p>
                                                    {vm.GPU && (
                                                        <p className="resource_card_items_inner">GPU {vm.GPU}</p>
                                                    )}
                                                </div>
                                                {vm?.vm_size !== "Shared_Erioon" && (
                                                    <div className="resource_card_items">
                                                        <p className="resource_card_items_inner">Min Nodes {vm.min_nodes}</p>
                                                        <p className="resource_card_items_inner">Max Nodes {vm.max_nodes}</p>
                                                    </div>
                                                )}
                                                <p className="resource_card_price">
                                                    {vm.price_per_hour_usd != null
                                                        ? (vm.erioon_price < 0.09
                                                            ? `$${vm.erioon_price}`
                                                            : `$${vm.erioon_price.toFixed(2)}`
                                                        ) + "/hour"
                                                        : "Pricing unavailable"}
                                                </p>
                                            </div>
                                        ))
                                )} */}
                            </div>

                        )}


                    </div>
                    <div className="cost_preview_container">
                        <div className="cost_preview_cont">
                            <p className="new_section_main_input_hint_title">
                                Price  {selectedVm.price_per_hour_usd != null
                                    ? ((Number(selectedVm.erioon_price) * nodes) < 0.01
                                        ? `$${Number(selectedVm.erioon_price) * nodes}`
                                        : `$${(Number(selectedVm.erioon_price) * nodes).toFixed(2)}`
                                    ) + "/hour"
                                    : "Pricing unavailable"} <span className="price_info" onClick={() => setShowPricingModal(true)}><i className="fa-solid fa-info"></i></span>
                            </p>
                            <p className="new_section_main_input_hint_description">
                                Billed on the 3rd each month.
                            </p>
                        </div>
                        <div className="preview_cont_db">
                            <div className="review_cont">
                                <p className="review_cont_title">Resume for Erioon {selectedVm.vm_size}</p>
                                <p className="review_cont_data"> <span>{selectedVm.notes}</span></p>
                                <p className="review_cont_data">vCPUs <span>{Number(selectedVm.vCPUs) * nodes}</span></p>
                                <p className="review_cont_data">RAM <span>{Number(selectedVm.RAM_GB) * nodes}GB</span></p>
                                <p className="review_cont_data">Nodes <span>{selectedVm.min_nodes} - {selectedVm.max_nodes}</span></p>



                                <div className="label_input_section_db">
                                    <label>Cluster name *</label>
                                    <input
                                        value={k8sName}
                                        onChange={(e) => setK8sName(e.target.value)}
                                        placeholder="ML Deployment Cluster"
                                    />
                                </div>
                                {selectedVm.type != "shared" && (
                                    <>
                                        <div className="label_input_section_db">
                                            <label>Nodes *</label>
                                            <input
                                                min={1}
                                                value={nodes}
                                                type="number"
                                                onChange={(e) => setNodes(e.target.value)}
                                                placeholder="3"
                                            />
                                        </div>
                                        <div className="label_input_section_db">
                                            <label>OS Type</label>
                                            <select disabled value={osType} onChange={(e) => setOsType(e.target.value)}>
                                                <option value={"Linux"}>Linux</option>
                                                <option value={"Windows"}>Windows</option>
                                            </select>
                                        </div>
                                    </>
                                )}

                                <div className="label_input_section_db">
                                    <label>Description *</label>
                                    <input
                                        value={description}
                                        onChange={(e) => setDescription(e.target.value)}
                                        placeholder="Cluster for ML model training"
                                        className="description_area_input"
                                    />
                                </div>

                            </div>
                            <ErrorMessage err={err} />
                            <button
                                // disabled={!hasPayment || loadingVMs}
                                className={`save_btn_db ${!hasPayment ? "save_btn_db_disabled" : ""}`}
                                onClick={NewDb}
                            >
                                {loading ? <Spinner loading={loading} /> : <><i className="fa-solid fa-plus"></i> Create cluster</>}
                            </button>

                        </div>
                    </div>
                    <PricingModal
                        show={showPricingModal}
                        handleClose={() => setShowPricingModal(false)}
                        pricing_data={selectedVm}
                    />
                </div>
            </div>
        </div>
    );
};

export default NewCluster;
